import { Col,Row, Typography,Statistic } from "antd";
import React  from "react";
import { useGetCryptosQuery } from "./sevices/cryptoApi";
import millify from "millify";
import { Link } from "react-router-dom";
import Cryptocurencies from "./Cryptocurrencies";
import { News } from ".";
import Loader from "./Loader";


const HomePage=()=>{

  const {data,isFetching}= useGetCryptosQuery(10);

  if(isFetching) return <Loader/>

  {console.log(data)}
    const {Title}=Typography
    const globalStates= data?.data.stats

    return (
       <>
       <Title level={2} className="Heading">
         <Row>
             <Col span={12}> <Statistic  title="Total Cryptocurrencies" value={millify(globalStates?.totalCoins)}></Statistic></Col>
             <Col span={12}> <Statistic  title="Total Exchanges" value={millify(globalStates?.totalExchanges)}></Statistic></Col>
             <Col span={12}> <Statistic  title="Total Market Cap" value={millify(globalStates?.totalMarketCap)}></Statistic></Col>
             <Col span={12}> <Statistic  title="Total 24H Volume" value={millify(globalStates?.total24hVolume)}></Statistic></Col>
             <Col span={12}> <Statistic  title="Total Markets" value={millify(globalStates.totalMarkets)}></Statistic></Col>
         </Row>
       </Title>
       <div className="home-heading-container">
         <Title level={2} className="home-title"> Top 10 Cryptocurrencies</Title>
         <Title level={5} className="show-more"><Link  to="/cryptocurencies"> show more</Link></Title>
       </div>
       <Cryptocurencies  simplified={true}/>
       <div className="home-heading-container">
       <Title level={2} className="home-title">Latest Crypto News</Title>
       <Title level={5} className="show-more"><Link  to="/cryptocurencies"> show more</Link></Title>
       </div>
       <News/>
       </>
    )
}

export default HomePage;